/* global Office console */

function checkAsyncResult(
  eventType: Office.EventType,
  result: Office.AsyncResult<void>,
  filterDescription: string,
  mode: string
) {
  if (result.status === Office.AsyncResultStatus.Succeeded) {
    console.log(`${mode} ${eventType} handler for ${filterDescription} OK`);
  } else {
    console.error(`${mode} ${eventType} handler for ${filterDescription} failed: ${result.error.message}`);
  }
}

export function registerAppointmentListeners(filterDescription: string, handleAppointmentChanged: () => void) {
  if (Office?.context?.mailbox?.item) {
    console.log(`Start adding listeners for ${filterDescription}`);
    Office.context.mailbox.item.addHandlerAsync(
      Office.EventType.AppointmentTimeChanged,
      (event: Office.AppointmentTimeChangedEventArgs) => {
        console.log(`Appointment time changed: [${event.start},${event.end}]`);
        handleAppointmentChanged();
      },
      (result) => checkAsyncResult(Office.EventType.AppointmentTimeChanged, result, filterDescription, "Add")
    );
    Office.context.mailbox.item.addHandlerAsync(
      Office.EventType.RecipientsChanged,
      (event: Office.RecipientsChangedEventArgs) => {
        if (event.changedRecipientFields.requiredAttendees || event.changedRecipientFields.optionalAttendees) {
          console.log(`Required and/or optional recipients changed`);
          handleAppointmentChanged();
        }
      },
      (result) => checkAsyncResult(Office.EventType.RecipientsChanged, result, filterDescription, "Add")
    );
    Office.context.mailbox.item.addHandlerAsync(
      Office.EventType.RecurrenceChanged,
      (event: Office.RecurrenceChangedEventArgs) => {
        console.log(`Recurrence changed: ${event.recurrence.recurrenceType}`);
        handleAppointmentChanged();
      },
      (result) => checkAsyncResult(Office.EventType.RecurrenceChanged, result, filterDescription, "Add")
    );
  }
}

export function removeAppointmentListeners(filterDescription: string) {
  if (Office?.context?.mailbox?.item) {
    console.log(`Start removing listeners for ${filterDescription}`);
    Office.context.mailbox.item.removeHandlerAsync(Office.EventType.AppointmentTimeChanged, (result) =>
      checkAsyncResult(Office.EventType.AppointmentTimeChanged, result, filterDescription, "Remove")
    );
    Office.context.mailbox.item.removeHandlerAsync(Office.EventType.RecipientsChanged, (result) =>
      checkAsyncResult(Office.EventType.RecipientsChanged, result, filterDescription, "Remove")
    );
    Office.context.mailbox.item.removeHandlerAsync(Office.EventType.RecurrenceChanged, (result) =>
      checkAsyncResult(Office.EventType.RecurrenceChanged, result, filterDescription, "Remove")
    );
  }
}
